<template>
  <section class="personal-center-panel">
    <h2>我的会议</h2>
    <ul v-if="front.myRegistrationSummaries.length" class="registration-summary-list">
      <li v-for="item in front.myRegistrationSummaries" :key="item.registrationId">
        <span>{{ item.conferenceTitle }}</span>
        <span>{{ item.statusLabel }}</span>
      </li>
    </ul>
    <p v-else>暂无报名会议</p>
    <button type="button" class="primary-action compact" @click="front.goServicesTab('conference')">前往会议服务</button>
  </section>
</template>

<script>
export default {
  name: 'PersonalConferencesPanel',
  inject: ['front']
}
</script>
